import { render, staticRenderFns } from "./ChatGpt-EmailTemplates.vue?vue&type=template&id=aa01cde2&scoped=true"
import script from "./ChatGpt-EmailTemplates.vue?vue&type=script&lang=js"
export * from "./ChatGpt-EmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./ChatGpt-EmailTemplates.vue?vue&type=style&index=0&id=aa01cde2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa01cde2",
  null
  
)

export default component.exports